import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;

  const [dataImport, setDataImport] = useState({});

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { CardCode: item.CODIGO, quota: item.CUOTA };
        }),
        CardName: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType="C"
          entity="base/business-partner"
          setBPartnerSelect={setBPartnerSelect}
        />
      ) : undefined}

      <Modal
        title={`Cuota para: ${cuota.CardName}`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          bPartnerSelect?.id
            ? 'sale/customer-provider-quote'
            : 'sale/customer-provider-quote/multiple'
        }
        dataForce={
          bPartnerSelect?.id
            ? {
                base_provider_id: cuota.valueSearch?.base_provider_id,
                base_business_partner_id: bPartnerSelect?.id
              }
            : {
                base_provider_id: cuota.valueSearch?.base_provider_id,
                customers: bPartnerSelect?.customers,
                force: 'Y'
              }
        }
        state
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="period_date"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.period_date).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <TextField
            key={openModalBPartner + bPartnerSelect?.CardName}
            label="Cliente"
            type="text"
            defaultValue={bPartnerSelect?.CardName || ''}
            margin="normal"
            onFocus={(e) => {
              e.preventDefault();
              e.currentTarget.blur();
            }}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment
                  style={{ cursor: 'pointer', color: '#07c107' }}
                  onClick={() => setOpenModalBPartner(true)}
                  position="start"
                >
                  <Search />
                </InputAdornment>
              )
            }}
            fullWidth
          />

          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGO"
            sortDuplicate="CODIGO"
            downTemplate={{
              fileNameDown: `${cuota?.valueSearch?.period_date}_${cuota?.CardName}`,
              fields: ['CODIGO', 'CUOTA']
            }}
          />
        </span>
        {bPartnerSelect?.id ? (
          <TextField
            label="Cuota"
            fullWidth
            type="number"
            name="quota"
            margin="normal"
            defaultValue={cuota.quota || ''}
            required
          />
        ) : undefined}
      </Modal>
    </>
  );
});
